import React from "react";

const LeftSticky = () => (
  <div className="tooltip tooltip--left-sticky-view">
    <p className="tooltip__text" />
  </div>
);

export default LeftSticky;
